import { ConfigurationTypeDto } from '@up/data';

export class ConfigThirdPartyAuthValueDto {
  id: number;
  configurationTypeId: number;
  value: string;
  configurationType: ConfigurationTypeDto
}